let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("8iQSy")]).then(() => parcelRequire('9c7ho'));